export type PlaygroundMode = 'async' | 'poll';

export const DEFAULT_PROXY_TIMEOUT_MS = 65_000;
export const PLAYGROUND_DEFAULT_TIMEOUT_MS = 30_000;
export const PLAYGROUND_MAX_TIMEOUT_MS = 120_000;

function normalizeTimeout(value: unknown): number | null {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return null;
  }

  const rounded = Math.round(value);
  if (rounded <= 0) {
    return null;
  }

  return rounded;
}

export function clampPlaygroundTimeoutMs(timeoutMs: unknown, maxTimeoutMs: number): number | null {
  const normalized = normalizeTimeout(timeoutMs);
  if (normalized === null) {
    return null;
  }
  return Math.min(maxTimeoutMs, normalized);
}

export function resolvePlaygroundUpstreamTimeoutMs(
  mode: PlaygroundMode,
  _normalizedPayload: Record<string, unknown> | null,
): number {
  return DEFAULT_PROXY_TIMEOUT_MS;
}
